import { Checkbox } from './Checkbox';
import { Color } from './Color';
import { ImgSize } from './ImgSize';
import { Monospace } from './Monospace';
import { Video } from './Video';
import { YfmCut } from './YfmCut';
import { YfmDist } from './YfmDist';
import { YfmFile } from './YfmFile';
import { YfmHeading } from './YfmHeading';
import { YfmNote } from './YfmNote';
import { YfmTable } from './YfmTable';
import { YfmTabs } from './YfmTabs';
export * from './Checkbox';
export * from './Color';
export * from './ImgSize';
export * from './Monospace';
export * from './Video';
export * from './YfmDist';
export * from './YfmCut';
export * from './YfmFile';
export * from './YfmHeading';
export * from './YfmNote';
export * from './YfmTable';
export * from './YfmTabs';
export const YfmPreset = (builder, opts) => {
    var _a, _b, _c, _d, _e, _f, _g;
    builder
        .use(Checkbox, (_a = opts.checkbox) !== null && _a !== void 0 ? _a : {})
        .use(Color)
        .use(ImgSize, (_b = opts.imgSize) !== null && _b !== void 0 ? _b : {})
        .use(Monospace)
        .use(Video, (_c = opts.video) !== null && _c !== void 0 ? _c : {})
        .use(YfmDist)
        .use(YfmCut, (_d = opts.yfmCut) !== null && _d !== void 0 ? _d : {})
        .use(YfmNote, (_e = opts.yfmNote) !== null && _e !== void 0 ? _e : {})
        .use(YfmFile)
        .use(YfmHeading, (_f = opts.yfmHeading) !== null && _f !== void 0 ? _f : {})
        .use(YfmTable, (_g = opts.yfmTable) !== null && _g !== void 0 ? _g : {})
        .use(YfmTabs);
};
